const wavePaths = document.querySelectorAll('.js-wave');
const characters = document.querySelectorAll('.js-character');

function moveElementsAlongPath() {
  characters.forEach(function(element, index) {
    const wavePath = wavePaths[index];
    const pathLength = wavePath.getTotalLength();
    const distance = (performance.now() / 1000) * 100;
    const reversedDistance = pathLength - (distance % pathLength);

    const point = wavePath.getPointAtLength(reversedDistance);

    element.setAttribute('x', point.x - (element.getAttribute('width') / 2));
    element.setAttribute('y', point.y - (element.getAttribute('height') / 2));
  });

  requestAnimationFrame(moveElementsAlongPath);
}

moveElementsAlongPath();